export default __webpack_public_path__ + "static/media/08.b1e9ca0a.png";